import { getEditorColor } from '../../util/ColorUtil';
import { modifyLinks, renderTextColor } from '../../util/DataUtil';
import { useRouter } from 'next/router';

const LargeLogoWall = ({
  data,
  text,
  renderLogos,
  getAlignment,
  isH2ClassStyled,
}) => {
  const emphasizedTextColor = getEditorColor(text);
  const { locale } = useRouter();

  return (
    <div
      className={`large-logo-wall${isH2ClassStyled ? ' headline-h2-class-styled' : ''}`}
    >
      <div className={'inner-container'}>
        {text && (
          <div className={'text ' + getAlignment()}>
            <h2
              className={`${isH2ClassStyled ? 'h2-class-styled' : ''} ${data?.regionColor ? renderTextColor(data?.regionColor) : ''} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              dangerouslySetInnerHTML={{
                __html: modifyLinks(text, locale)
                  .replace(/<\/?p>/gi, '')
                  .replace(/<\/?h2>/gi, ''),
              }}
            />
          </div>
        )}
      </div>
      <div className={'logos-container'}>{renderLogos()}</div>
    </div>
  );
};

export default LargeLogoWall;
